import React from 'react'

import { SecurityView } from './SecurityView'
import { useSecurity } from './hooks/useSecurity'

export const SecurityContainer = () => {
  const security = useSecurity()

  return <SecurityView {...security} />
}
